import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-recap-achat',
    templateUrl: './recap-achat.component.html',
    styleUrls: ['./recap-achat.component.scss']
})
export class RecapAchatComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    workDetail = false;
    squareDetail = false;

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public commonService: CommonService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
    }

    edit(event, fields = '', i = -1) {
        this.favorite = this.adService.cleanInput(this.favorite);

        if (fields === 'price' || fields === 'estate_sale') {
            // Set to null to calculate it
            if (this.favorite.apport === this.favorite.notary_price) {
                this.favorite.apport = null;
            }
            this.favorite.notary_price = null;
        }

        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'price') {
                this.favorite.other_fees = null;
            } else if (fields === 'works_help' || fields === 'works_square_price' || fields === 'works_total') {
                this.favorite.other_fees_work = null;
            } else if (fields === 'square') {
                this.favorite.building_insurance = null;
            }
        }

        if (this.favorite.lots.length === 1) {
            if (fields === 'works_total') {
                this.favorite.works_help = -1;
                this.favorite.works_square_price = null;
            } else if (fields === 'works_square_price') {
                this.favorite.works_total = null;
            }
        } else {
            if (fields === 'works_total') {
                this.favorite.lots[i].works_help = -1;
                this.favorite.lots[i].works_square_price = null;
            } else if (fields === 'works_square_price') {
                this.favorite.lots[i].works_total = null;
            }
        }

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    showWorkDetail() {
        this.workDetail = true;
    }

    hideWorkDetail() {
        this.workDetail = false;
    }

    showSquareDetail() {
        this.squareDetail = true;
    }

    hideSquareDetail() {
        this.squareDetail = false;
    }
}
